import {GREY} from '../../colors'
import {BU_ICON} from '../block-units'

export const ICON_MAIN = 'icon_main'

export const getBlockIconModel = (fontAwesomeIconKey = 'question-circle') => ({
    key: ICON_MAIN,
    unit: BU_ICON,
    fontAwesomeIconKey,
    attrs: {
        color: GREY
    },
    editableAttrs: {
        color: {
            label: 'Color',
            type: 'color'
        }
    }
})
